import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChange } from '@angular/core';
import { TreeNode, TreeNodeTypes } from './models';
import { ReplaySubject } from 'rxjs';
import { CExpandStatus } from 'app/datasources/constants';

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss']
})

export class TreeComponent implements OnInit, OnChanges {
  CExpandStatus = CExpandStatus;
  @Input() public searchMode: 'native' | 'passthrough' | 'none' = 'none';
  @Input() public searchBoxPlaceholder = 'Search';

  @Input() public treeData: TreeNode[] | undefined;
  @Output() public treeDataChange = new EventEmitter<TreeNode[]>();

  @Input() public searchValue = '';
  @Output() public searchValueChange = new EventEmitter<string>();

  @Output() public loadFrom = new EventEmitter<TreeNode>();
  @Output() metricActionTriggered = new EventEmitter<string>();
  // to emit expand and collapse status
  @Output() public expandStatus = new EventEmitter<any>();

  public dataSource: TreeNode[] = [];
  private originalSource: TreeNode[] = [];
  expandedRows: TreeNode[] = [];

  @Input() public selectedNode: TreeNode;
  @Output() public selectedNodeChange = new EventEmitter<TreeNode>();
  @Input() treeType = '';

  private readonly treeDataSubject: ReplaySubject<TreeNode[]>;
  readonly TreeNodeTypes = TreeNodeTypes;

  constructor() {
    this.treeDataSubject = new ReplaySubject(1);
  }

  ngOnInit(): void {
    console.log('treeType: ', this.treeType);
    this.treeDataSubject.subscribe(sub => {
      if (!this.searchValue || this.searchValue === '') {
        this.originalSource = sub;
      }

      if(!this.dataSource?.length){
        this.expandedRows = [];
      }

      this.dataSource = sub;
      console.log('this.dataSource: ', this.dataSource);
      if (this.expandedRows.length) {
        this.dataSource.forEach((dataSource: TreeNode) => {
          this.expandedRows.filter((expandedRow: TreeNode) => {
            if (dataSource.fqn === expandedRow.fqn) {
              dataSource.expanded = true;
            }
          });
        });
      }
    });
  }

  /**
   * expand and collapase status
   * @param status expand status
   */
  expandAndCollapse(status: string, node: TreeNode){
    if (node.expanded === true) {
      this.expandedRows.push(node);
    } else if (!node.expanded) {
      this.expandedRows.forEach((expandedRow: TreeNode, index: number) => {
        if (expandedRow.fqn === node.fqn) {
          this.expandedRows.splice(index, 1);
        }
      });
    }

    console.log('status: ', status);
    console.log('node: ', node);
    this.expandStatus.emit({status: status, node: node});
  }

  ngOnChanges(change: { [key: string]: SimpleChange }) {
    if (change.treeData) {
      this.treeDataSubject.next(this.treeData);
    }
  }

  shouldRender(node: TreeNode) {
    const parent = this.getParentNode(node);
    return !parent || parent.expanded;
  }

  getParentNode(node: TreeNode) {
    const nodeIndex = this.treeData.indexOf(node);

    for (let i = nodeIndex - 1; i >= 0; i--) {
      if (this.treeData[i].level === node.level - 1) {
        return this.treeData[i];
      }
    }

    return null;
  }

  loadMore(currentNode: TreeNode) {
    console.log('currentNode :>> ', currentNode);
    if (currentNode.nodeType === TreeNodeTypes.DEVICE_METRIC
      || currentNode.nodeType === TreeNodeTypes.DEVICE_METRIC_PROPERTY
      || currentNode.nodeType === TreeNodeTypes.NODE_METRIC
      // || currentNode.nodeType === TreeNodeTypes.NODE
      || currentNode.nodeType === TreeNodeTypes.NODE_METRIC_PROPERTY) {
      return;
    }

    this.loadFrom.next(currentNode);
  }

  hasChild = (_: number, node: TreeNode) => node.expandable;

  onNodesSearch(val: string) {
    this.searchValueChange.emit(val);
  }

  onClearSearch() {
    this.dataSource = Object.assign([], this.originalSource);
    this.searchValue = '';
  }
}
